<template>
  <div id="app">
    <NavBar class="nav-bar" />

      <router-view  />

    <FooterBar />
    <!-- 带收起/展开功能的留言框 -->
    <div class="foot-box" :class="{ 'collapsed': isCollapsed }">
      <!-- 收起状态下显示的小图标/文字 -->
      <div v-if="isCollapsed" class="collapsed-indicator" @click="toggleCollapse">
        <i class="fas fa-comment-dots"></i>
        <span>咨询</span>
      </div>

      <!-- 展开状态下显示的完整内容 -->
      <div v-else>
        <div class="box-title">
          <div>咨询</div>
          <div class="close-btn" @click="toggleCollapse">
            <i class="fas fa-chevron-down"></i>
          </div>
        </div>
        <div class="box-body">
          <div>您好！如果您想咨询补己招商代理，可以填写您的信息，我们会尽快与您联系！</div>
          <div class="inputs-container">
            <input type="text" placeholder="姓名" />
            <input type="text" placeholder="电话（必填）" />
            <input type="text" placeholder="加盟地区（必填）" />
            <div class="box-btn">提交</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import { ref } from 'vue';
import NavBar from './components/NavBar.vue';
import FooterBar from './components/FooterBar.vue';
import AppContainer from './components/AppContainer.vue'

// 控制留言框收起/展开的状态
const isCollapsed = ref(true);

// 切换收起/展开状态的方法
const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value;
};
</script>

<style scoped>
/* 引入Font Awesome图标库 */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css');
#app{
  min-width: 1400px;
}


input {
  width: 100%;
  margin-top: 10px;
  border: 1px solid #D8CBBB;
  padding: 8px;
  border-radius: 4px;
  box-sizing: border-box;
}

.foot-box {
  height: 380px;
  width: 280px;
  position: fixed;
  bottom: 150px;
  left: 20px;
  z-index: 99999;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  cursor: pointer;
  overflow: hidden;
}

/* 收起状态的样式 */
.foot-box.collapsed {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #51423B;
}

.box-body {
  padding: 15px;
}

.box-title {
  background-color: #51423B;
  color: white;
  padding: 12px 15px;
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.box-btn {
  background-color: #51423B;
  width: 80px;
  color: white;
  font-size: 18px;
  text-align: center;
  padding: 6px;
  border-radius: 8px;
  margin-top: 20px;
  margin-left: auto;
  cursor: pointer;
  transition: background-color 0.2s;
}

.box-btn:hover {
  background-color: #3d312b;
}

.inputs-container {
  margin-top: 15px;
}

.close-btn {
  font-size: 16px;
  transition: transform 0.3s ease;
}

/* 收起状态下的指示器 */
.collapsed-indicator {
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 12px;
}

.collapsed-indicator i {
  font-size: 20px;
  margin-bottom: 4px;
}

/* 旋转图标表示收起状态 */
.foot-box.collapsed .close-btn i {
  transform: rotate(180deg);
}

* {
  padding: 0;
  margin: 0;
}

.nav-bar {
  position: fixed;
  top: 0;
}
</style>
